import { Elastic, Power4, gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { createResultCollector } from './improvise';
import { isMobile } from "./uilts";

class Celebration {

    celebrateTimeline;
    celebrateElem;

    celebrateOrbitWrapper;
    celebrateTitleWrapper

    celebrateScrollWrapperElem;
    celebrateItemContainer;

    celebrateLineElem;          // 기본 라인 애니메이션 (노티)
    celebrateLineReverseElem;   // 역방향 라인 애니메이션 (노티)

    celebratePersonList;

    // 팝업 제어.
    celebratePopupPageList;
    celebratePopupBtnList;
    celebratePopupCloseBtnList;

    celebratePopupCopylinkElem;             // 링크복사 확인팝업.
    celebratePopupCopylinkCloseList;        // 링크복사 확인 버튼 / 닫기 버튼.

    firstElem;

    // SNS 쉐어.
    celebrateWaveList;
    celebratelastTitle;


    totalScrollWidth;

    waveTimeline;
    thanksTimeline;
    

    isOpenPopup = [false, false, false, false, false, false, false, false];
    isOpenCopyLinkPopup = false;

    totalScrollTime = 0;

    //===================================================================
    // 트랜지션 커버 제어용
    //===================================================================
    visionCoverElem;    // 이전 세션 커버.

    constructor() {
      
        this.celebrateElem = document.querySelector('.celebrate');
        this.celebrateScrollWrapperElem = this.celebrateElem.querySelector('.scroll-wrapper');
        this.celebrateItemContainer = this.celebrateElem.querySelector('.item-container');

        this.celebrateOrbitWrapper = this.celebrateElem.querySelector('.celebrate-orbit-wrapper');
        this.celebrateTitleWrapper = this.celebrateElem.querySelector('.celebrate-title-wrapper');

        this.celebrateLineElem = document.querySelector('#lottie-bg-celebrate-line');
        this.celebrateLineReverseElem = document.querySelector('#lottie-bg-celebrate-line-reverse');
        
        this.celebratePersonList = gsap.utils.toArray('.celebrate .item-container .item .person');

        this.celebrateWaveList = gsap.utils.toArray('.share-wrapper .wave-group .wave');
        this.celebratelastTitle = document.querySelector('.share-wrapper .contents');

        this.dimBackgroundElem = document.querySelector('.container .background-dim');
        this.celebratePopupPageList = document.querySelectorAll('.celebrate-popup'); 

        this.visionCoverElem = document.querySelector('.transiton-cover.vision-page');

        this.firstElem = document.querySelector('.person.celebrate-1');

        this.celebratePopupBtnList = document.querySelectorAll('.person .text-area .show-more');
        this.celebratePopupBtnList.forEach((elem, index) => {
            elem.addEventListener('click', () => {
                if(this.isOpenPopup[index]) return;
                this.openCelebratePopup('flex', index);
            });
        });

        this.celebratePopupCloseBtnList = document.querySelectorAll('.celebrate-popup .close');
        this.celebratePopupCloseBtnList.forEach((elem, index) => {
            elem.addEventListener('click', () => {
                if(!this.isOpenPopup[index]) return;
                this.openCelebratePopup('none', index);
            });
        });

        this.celebratePopupCopylinkElem = document.querySelector('.celebrate-copy-popup');
        this.btnShareLink = document.querySelector('#btn-share-link');
        this.btnShareLink.addEventListener('click', () => {
            this.copyLinkURLtoClipboard();
        });
        this.celebratePopupCopylinkCloseList = gsap.utils.toArray('#copy-popup-close');
        this.celebratePopupCopylinkCloseList.forEach((elem) => {
            elem.addEventListener('click', () => {
                this.openCopyClipboardPopup('none');
            });
        });

    }

    init() {
        this.celebrateTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.celebrateElem,
                start: "top top",
                end: () => isMobile() ? `+=1500%` : `+=1500%`,
                scrub: 1,
                pin: true,
                pinSpacing: true,
                // markers: true,
                invalidateOnRefresh: true,
                id: 'celebrate',
                preventOverlaps: true,
                fastScrollEnd: true
        }});
        this.waveTimeline = gsap.timeline({ paused: true });
        this.thanksTimeline = gsap.timeline({paused: true});


        this.celebrateTimeline.to({}, {duration: 3});

        // 비디오 커버 열기.
        this.celebrateTimeline.to(this.visionCoverElem, { y:() => -window.innerHeight, duration: 3 });

        this.celebrateTimeline.set(this.visionCoverElem, {visibility: 'hidden'});

        this.celebrateTimeline.set(this.celebrateLineElem, {css: {display: 'block'}});
        this.celebrateTimeline.set(this.celebrateLineReverseElem, {css: {display: 'none'}});


        // 첫번째 인물 소개란 페이드 형식으로 등장.
        this.celebrateTimeline.fromTo(this.firstElem, {opacity: 0}, {opacity: 1, duration: 3, ease: Elastic.easeOut(1, 0.75) },"+=5");

        // =======================================================================================================================
        // Mobile.
        // =======================================================================================================================
        if(isMobile()) {

            // 세로 스크롤.
            this.celebrateTimeline.to(this.celebrateScrollWrapperElem, {y: () => `-${window.innerHeight - (this.celebrateItemContainer.querySelector('.person.celebrate-1').offsetHeight / 2)}`, duration: 10},"+=10");
            this.celebrateTimeline.to(this.celebrateScrollWrapperElem, {y: () => `-${window.innerHeight * 5}`, duration: 50},"+=10");

            // this.celebrateTimeline.set(this.celebrateLineElem, {css: {display: 'none'}});
            // this.celebrateTimeline.set(this.celebrateLineReverseElem, {css: {display: 'block'}});

            this.celebrateTimeline.to(this.celebrateOrbitWrapper, {autoAlpha: 0, duration: 2}, "-=70");
            this.celebrateTimeline.to(this.celebrateTitleWrapper, {autoAlpha: 0, duration: 2}, "-=2");
            
            // this.celebrateTimeline.fromTo(this.celebratePersonList[0], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=35");
            // this.celebrateTimeline.fromTo(this.celebratePersonList[1], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=40");
            // this.celebrateTimeline.fromTo(this.celebratePersonList[2], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=50");
            // this.celebrateTimeline.fromTo(this.celebratePersonList[3], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=66");
            // this.celebrateTimeline.fromTo(this.celebratePersonList[4], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=70");
            // this.celebrateTimeline.fromTo(this.celebratePersonList[5], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=83");
            // this.celebrateTimeline.fromTo(this.celebratePersonList[6], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=90");
            // this.celebrateTimeline.fromTo(this.celebratePersonList[7], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=95");

            this.celebrateTimeline.to(this.celebratePersonList[7], { opacity: 0, duration: 2});
    
            // 웨이브.
            this.celebrateWaveList.forEach((elem, index) => {
                this.celebrateTimeline.to(elem, {scale: 1, opacity: 0, duration: 5, ease: Power4.easeOut}, index === 0 ? '+=0' : `-=4`);
            });     
            // 공유 버튼 보이기.
            this.celebrateTimeline.fromTo(this.celebratelastTitle, { opacity: 0 }, { opacity: 1, duration: 3 }, '-=4');

            this.celebrateTimeline.to({},{duration: 1},"+=10");
        
        // =======================================================================================================================
        // Desktop.
        // =======================================================================================================================
        } else {


            // 가로 스크롤.
            if(window.innerWidth > 1024)    this.celebrateTimeline.to(this.celebrateScrollWrapperElem, {x: () => -window.innerWidth + (this.celebrateItemContainer.querySelector('.person.celebrate-1').offsetWidth / 2) - (window.innerWidth * 0.08), duration: 6});
            else                            this.celebrateTimeline.to(this.celebrateScrollWrapperElem, {x: () => -window.innerWidth + (window.innerWidth * 0.08), duration: 6});
            this.celebrateTimeline.to(this.celebrateScrollWrapperElem, {x: () => `-${window.innerWidth * 5}`, duration: 40},"+=6");

            // this.celebrateTimeline.set(this.celebrateLineElem, {css: {display: 'none'}});
            // this.celebrateTimeline.set(this.celebrateLineReverseElem, {css: {display: 'block'}});
            
            // this.celebrateTimeline.to(this.celebrateScrollWrapperElem, {x: () => `-=${this.celebrateItemContainer.offsetWidth - this.celebrateItemContainer.querySelector('.item').offsetWidth}`, duration: 60});

            this.celebrateTimeline.to(this.celebrateOrbitWrapper, {autoAlpha: 0, duration: 5}, "-=52");
            this.celebrateTimeline.to(this.celebrateTitleWrapper, {autoAlpha: 0, opacity: 0, duration: 5}, "-=52");

            // this.celebrateTimeline.fromTo(this.celebratePersonList[0], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=35");
            // this.celebrateTimeline.fromTo(this.celebratePersonList[1], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=40");
            // this.celebrateTimeline.fromTo(this.celebratePersonList[2], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=50");
            // this.celebrateTimeline.fromTo(this.celebratePersonList[3], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=66");
            // this.celebrateTimeline.fromTo(this.celebratePersonList[4], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=70");
            // this.celebrateTimeline.fromTo(this.celebratePersonList[5], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=83");
            // this.celebrateTimeline.fromTo(this.celebratePersonList[6], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=90");
            // this.celebrateTimeline.fromTo(this.celebratePersonList[7], {opacity: 0}, { opacity: 1, duration: 5},"reveal+=95");

            this.celebrateTimeline.to(this.celebratePersonList[7], { autoAlpha: 0, duration: 2});

    
            // 웨이브.
            this.celebrateWaveList.forEach((elem, index) => {
                this.celebrateTimeline.to(elem, {scale: 1, opacity: 0, duration: 5, ease: Power4.easeOut}, index === 0 ? '+=10' : `-=4`);
            });     
            // 공유 버튼 보이기.
            this.celebrateTimeline.fromTo(this.celebratelastTitle, { opacity: 0 }, { opacity: 1, duration: 10 }, '-=10');
            
        }


        // this.celebrateTimeline.to({},{duration: 1},"+=2");
        
        

        // this.celebrateWaveList.forEach((elem, index) => {
        //     this.waveTimeline.to(elem, {scale: 1, opacity: 0, duration: 5, ease: Power4.easeOut}, index === 0 ? '+=0' : `-=4`);
        // }); // 20 + 8 + 4 = 32

        // this.thanksTimeline.fromTo(this.celebratelastTitle, { opacity: 0 }, { opacity: 1, duration: 5 });

        // this.waveTimeline.play();
        // this.thanksTimeline.play();

        const [animations, lottieScrollTrigger] = createResultCollector(this.lottieScrollTriggerCelebrate.bind(this))

        lottieScrollTrigger({
            target: `#lottie-bg-celebrate-line`,
            path: isMobile() ? './assets/lottie/MO_Clebrate_5_01-07_Line_Appear.json' : './assets/lottie/Celebrate_5_01-07_Line_Appear.json',
            // start: () => isMobile() ? `${targetTimeline.scrollTrigger.end - (window.innerHeight * 4)} top` : `${targetTimeline.scrollTrigger.end - this.celebrateItemContainer.querySelector('.item').offsetWidth * 2} bottom`, //  * 1.5
            // end: () => isMobile() ? `${targetTimeline.scrollTrigger.end} bottom` : `${targetTimeline.scrollTrigger.end} bottom`,
            start:() =>  isMobile() ? `30% top` : `160% top`,
            end:() => isMobile() ? `+=800%` : `+=850%`,
            id: `lottie-bg-celebrate-line`,
            preserveAspectRatio: 'none', //'xMinYMid meet',
            // markers: true,
            direction: 'normal',
            onLeave: () => {
                this.setNormalLineElement('none');
            },
            onEnterBack: () => {
                this.setNormalLineElement('flex');
            },
        });
        lottieScrollTrigger({
            target: `#lottie-bg-celebrate-line-reverse`,
            path:  isMobile() ? './assets/lottie/MO_Celebrate_5_01-07_Line_Disppear.json' : './assets/lottie/Celebrate_5_01-07_Line_Disppear.json',
            // start: () => isMobile() ? `${targetTimeline.scrollTrigger.end - (window.innerHeight * 4)} top` : `${targetTimeline.scrollTrigger.end - this.celebrateItemContainer.querySelector('.item').offsetWidth * 1.5} top`, //  * 1.5
            // end: () => isMobile() ? `${targetTimeline.scrollTrigger.end + window.innerHeight} bottom` : `${targetTimeline.scrollTrigger.end + window.innerHeight} bottom`,
            start:() => isMobile() ? `30% center` : `550% top`,
            end:() => isMobile() ? `+=950%` : `+=750%`,
            id: `lottie-bg-celebrate-line-revese`,
            preserveAspectRatio: 'none', //'xMinYMid meet',
            // markers: true,
            direction: 'reverse',
            // onLeave: () => {
            //     this.waveTimeline.play();
            //     this.thanksTimeline.play();
            // },
            // onEnterBack: () => {
            //     this.waveTimeline.reverse();
            //     this.thanksTimeline.reverse();
            // }            
        });

        return Promise.all(animations)

    }

    kill() {
        if(this.celebrateTimeline) {
            this.celebrateTimeline.eventCallback("onEnter", null);
            this.celebrateTimeline.eventCallback("onEnterBack", null);
            this.celebrateTimeline.eventCallback("onLeave", null);

            // this.celebrateTimeline.getChildren().forEach(child => {
            //     // gsap.set(child, {clearProps: "all"});
            //     child.kill();
            // });

            this.celebrateTimeline.clear().kill();
            this.celebrateTimeline = null;
        }
    }

    // window resize 이벤트 호출시 동작.
    refresh() {
        this.celebrateTimeline.invalidate();
    }

    /**
     * 팝업 제어.
     * @param {'flex' | 'none'} state : 팝업 열림 / 닫힘.
     * @param {number} index : 인덱스.
     */
    openCelebratePopup(state, index) {
        this.isOpenPopup[index] = (state === 'flex');
        document.querySelector('body').style.overflow = this.isOpenPopup[index] ? 'hidden' : 'visible';
        this.dimBackgroundElem.style.display = state;
        this.celebratePopupPageList[index].style.display = state;
    }

    /**
     * 팝업 제어.
     * @param {'flex' | 'none'} state : 팝업 열림 / 닫힘.
     */
    openCopyClipboardPopup(state) {
        this.isOpenCopyLinkPopup = (state === 'flex');
        document.querySelector('body').style.overflow = this.isOpenCopyLinkPopup ? 'hidden' : 'visible';
        this.dimBackgroundElem.style.display = state;
        this.celebratePopupCopylinkElem.style.display = state;
    }

    getTimeline() {
        return this.celebrateTimeline;
    }

    getScrollTrigger() {
        return this.celebrateTimeline.scrollTrigger;
    }

    loadLotties(targetTimeline ) {
        const lineTL =gsap.timeline({
            scrollTrigger: {
                invalidateOnRefresh: true
            }
        });
        const lineRvTL =gsap.timeline({
            scrollTrigger: {
                invalidateOnRefresh: true
            }
        });
    }

    lottieScrollTriggerCelebrate(vars) {
        const targetElem = document.querySelector(`${vars.target}`);
        if(targetElem.hasChildNodes()) {
            targetElem.innerHTML = '';
        }
        let playhead = { frame: 0 },
            target = targetElem,
            st = {
                trigger: vars.trigger ? document.querySelector(vars.trigger) : target,
                scrub: 1,
                // markers: true,
                // invalidateOnRefresh: true,
                onEnterBack: () => vars.onEnterBack,
                onLeave: () => vars.onLeave,
            },
            animation = bodymovin.loadAnimation({
                container: target,
                renderer: "svg",
                loop: false,
                autoplay: false,
                path: vars.path,
                initialSegment: vars.segment, // [0, 70] // totalFrames == 180
                rendererSettings: {
                    preserveAspectRatio: vars.preserveAspectRatio ?? 'xMidYMid meet'
                }
            });
        for (let p in vars) { // let users override the ScrollTrigger defaults
            st[p] = vars[p];
        }

        return new Promise((resolve) => {
            animation.addEventListener("DOMLoaded", function () {
                const backgroundLine = targetElem.id.startsWith('lottie-bg-') && targetElem.querySelector('svg g g g path');
                if(backgroundLine) {
                    // gsap.set(backgroundLine, {attr: {'stroke-width': 1}});
                    // console.log(lineYellow);
                }
                if (vars.timeline) {
                    vars.timeline.to(playhead, {
                        frame: animation.totalFrames - 1,
                        ease: "none",
                        onUpdate: () => {
                            // console.log(`${vars.target} - ${playhead.frame}`);
                            animation.goToAndStop(playhead.frame, true)
                        },
                        onComplete: () => vars.onComplete,
                        // onComplete: () => {
                        //     // targetElem.style.display = "none";
                        // },
                        scrollTrigger: st
                    });
                } else {
                    gsap.to(playhead, {
                        frame: animation.totalFrames - 1,
                        ease: "none",
                        onUpdate: () => {
                            // console.log(`${vars.target} - ${playhead.frame}`);
                            animation.goToAndStop(playhead.frame, true);
                        },
                        onComplete: () => vars.onComplete,
                        
                        scrollTrigger: st
                    });
                }
    
                resolve(animation);
            });
        })
    }

    /** 
     * 정방향으로 재생하는 라인 애니매이션이 마지막에 도달하면 숨김 처리.
     * 역방향 라인은 반대로 처리.
     * @param {'flex' | 'none'} state 숨기기 / 보이기
     */
    setNormalLineElement(displayState) {
        this.celebrateLineElem.style.display = displayState;
        this.celebrateLineReverseElem.style.display = displayState === 'flex' ? 'none' : 'flex';
    }




    //클립보드로 복사.
    copyLinkURLtoClipboard() {
        var dummy = document.createElement('input'),
            text = 'https://10th.rootimpact.org';
        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);

        // 팝업 띄우기.
        this.openCopyClipboardPopup('flex');
    }



}

export default Celebration;